/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
function t(t){return t?.operations?.data.geometry}export{t as manipulatedObjectGeometry};
